import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/SeminarManagement';

const GetAllSeminarReducer = handleActions({
    [Actions.GetAllSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetAllSeminarRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.GetAllSeminarRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload,
    }),
    [Actions.ClearSeminarData]: (state) => ({
        ...state,
        isFetching: false,
        success: true,
        errors: {},
        data: [],
    }),
}, {
    isFetching: false,
    success: false,
    errors: {},
    data: [],
});

const getDetailSeminarReducer = handleActions({
    [Actions.GetDetailSeminarIgnoreCompanyIdRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailSeminarIgnoreCompanyIdRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.GetDetailSeminarIgnoreCompanyIdRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        success: false,
        errors: action.payload,
    }),
    [Actions.ClearDetailSeminarData]: (state) => ({
        ...state,
        isFetching: false,
        success: false,
        errors: {},
        data: {},
    }),
}, {
    isFetching: false,
    success: false,
    errors: {},
    data: {},
});

const updateSeminarReducer = handleActions({
    [Actions.UpdateSeminarIgnoreCompanyIdRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.UpdateSeminarIgnoreCompanyIdRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.UpdateSeminarIgnoreCompanyIdRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        success: false,
        errors: action.payload,
    }),
    [Actions.ClearSeminarUpdateData]: (state) => ({
        ...state,
        isFetching: false,
        success: false,
        errors: {},
        data: {},
    }),
}, {
    isFetching: false,
    success: false,
    errors: {},
    data: {},
});

export default combineReducers({
    listSeminars: GetAllSeminarReducer,
    detail: getDetailSeminarReducer,
    update: updateSeminarReducer,
});
